<template>
  <div class="inline-flex items-center flex-1 overflow-hidden">
    <div v-if="!inputVisible" class="label-box">
      <!-- <a-tooltip
        :title="label"
        color="white"
        destroyTooltipOnHide
        overlayClassName="x-title-tip"
      > -->
      <span class="label">
        {{ label }}
      </span>
      <!-- </a-tooltip> -->
      <EditOutlined
        v-if="edit"
        class="ml-[2px] edit-icon"
        @click.stop="inputVisible = true"
      />
    </div>
    <a-input
      v-else-if="edit"
      ref="inputRef"
      v-model:value="inputValue"
      class="w-full label-input"
      type="text"
      :size="size || 'small'"
      show-count
      :spellCheck="false"
      :maxlength="maxlength"
      @blur="handleInputConfirm"
      @keyup.enter="handleInputConfirm"
    />
  </div>
</template>
<script lang="ts" setup>
interface IProps {
  label?: string
  edit?: boolean
  visible?: boolean
  size?: 'large' | 'middle' | 'small'
  maxlength?: number
  fontSize?: number

  'onUpdate:visible'?: (v: boolean) => void
  onChange?: (v: string) => void
}

const props = defineProps<IProps>()

const emit = defineEmits(['update:visible', 'change'])

const inputRef = ref()
const inputValue = ref(props.label)
const inputVisible = computed({
  get: () => props.visible || false,
  set: (v: boolean) => emit('update:visible', v),
})

watch(inputVisible, (v) => {
  if (v) {
    inputValue.value = props.label
    nextTick(() => inputRef.value.focus())
  } else {
    inputValue.value = ''
  }
})

const handleInputConfirm = () => {
  const value = inputValue.value || props.label
  emit('change', value)
  inputVisible.value = false
}
</script>
<style lang="scss" scoped>
.label-box {
  @apply inline-flex items-center max-w-full;
  .edit-icon {
    visibility: hidden;
  }
  &:hover {
    .edit-icon {
      visibility: visible;
    }
  }
}
.label-input {
  font-size: inherit;
}
.label {
  @apply truncate font-medium leading-[1.1] text-font-1;
}
</style>
